//@flow
import * as React from 'react';
import {
    Stack,
    Columns,
    Column,
    Text,
    Icon as NeoIcon
} from '@locus-taxy/neo-ui';
import { type BeatPlanEdits } from 'common/models/internal/BeatPlanEdits';
import { type FpBeat } from 'common/models/internal/FpBeat';

type AllocatedEditItemProps = {
    allocatedEdit: BeatPlanEdits,
    beats: Array<FpBeat>
};

export default class AllocatedEditItem extends React.PureComponent<AllocatedEditItemProps> {
    render() {
        const { allocatedEdit, beats } = this.props;
        const sourceBeatNumber = allocatedEdit.edits[0].sourceBeatId || '';
        const { targetBeatId } = allocatedEdit.edits[0];

        const targetbeat = beats.find(beat => {
            return beat.beatId === targetBeatId;
        });
        const { currentSalesmanId: targetBeatRider } = targetbeat;
        return (
            <Columns>
                <Column width="1/4">
                    <NeoIcon
                        icon="dispatcher_unallocate"
                        color="red.500"
                        size="medium"
                    />
                </Column>
                <Column width="1/4">
                    <Text fontSize={2}>{sourceBeatNumber}</Text>
                </Column>
                <Column width="1/4">
                    <Stack space="small">
                        <Text fontSize={2}>{targetBeatId}</Text>
                    </Stack>
                </Column>
                <Column width="1/4">
                    <Stack space="small">
                        <Text fontSize={2}>{targetBeatRider}</Text>
                    </Stack>
                </Column>
            </Columns>
        );
    }
}
